import { c as _c } from "react/compiler-runtime";
import { LayoutStack } from 'design-system/server';
import { useEffect } from 'react';
import GenericError from './GenericError';
import { report } from '@/errorReporting';
import { ErrorComponentProps } from '@/types';
function Error(t0) {
  const $ = _c(5);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      report(error, {
        tags: "client"
      });
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== reset) {
    t3 = <LayoutStack space="400"><GenericError reset={reset} /></LayoutStack>;
    $[3] = reset;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
Error.displayName = 'Error';
export default Error;